module.exports = __webpack_public_path__ + "js/4-fc33abe8707b3b90e9a5.chunk.worker.js"